import { Card, Typography } from "@arco-design/web-react";
import type { ReactNode } from "react";

const { Text } = Typography;

/** 指标卡组件属性。 */
export interface KpiCardProps {
  icon: ReactNode;
  label: string;
  value: string;
  trend: string;
  trendTone: "positive" | "negative";
}

/** 首页指标卡。 */
export function KpiCard({ icon, label, value, trend, trendTone }: KpiCardProps) {
  return (
    <Card
      bodyStyle={{ padding: 20 }}
      style={{
        border: "1px solid #e5e6eb",
        borderRadius: 18,
        boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)",
      }}
    >
      <div data-testid="workspace-kpi-card">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 18,
          }}
        >
          <div style={{ color: "#165dff" }}>{icon}</div>
          <Text
            style={{
              color: trendTone === "positive" ? "#00b42a" : "#f53f3f",
              fontWeight: 700,
            }}
          >
            {trend}
          </Text>
        </div>
        <div style={{ marginBottom: 10, color: "#1d2129", fontSize: 38, fontWeight: 700 }}>
          {value}
        </div>
        <Text style={{ color: "#4e5969", fontSize: 16, fontWeight: 500 }}>{label}</Text>
      </div>
    </Card>
  );
}
